/* Decorators configurator core — the shared behaviour of every configurator (docs/shopify/configurators.md).
   Load it before a configurator's own script:  <script src="{{ 'dcfg-core.js' | asset_url }}"></script>
   Everything a configurator does that is not about its own furniture lives here: prices, the cart, the address,
   copying a link, variant lookup, drag and drop, the phone bar, photos.
   Pushed by scripts/configurators_push.py — never edit the copy on the theme. */
(function (w) {
  'use strict';
  if (w.Dcfg) return;
  var D = {};

  /* ── money: the shop's own format, without ",00" (like Liquid's money_without_trailing_zeros) ── */
  D.money = function (cents) {
    var fmt = (w.theme && w.theme.settings && w.theme.settings.moneyFormat) || '{{amount_with_comma_separator}} lei';
    var n = (cents || 0) / 100;
    function grp(x, dec, th, ds) {
      var p = x.toFixed(dec).split('.');
      var tail = p[1] && !/^0+$/.test(p[1]) ? ds + p[1] : '';
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + tail;
    }
    return String(fmt).replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return grp(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(n, 0, '.', ',');
      if (k === 'amount_no_decimals') return grp(n, 0, ',', '.');
      if (k === 'amount_with_apostrophe_separator') return grp(n, 2, "'", '.');
      return grp(n, 2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  };
  /** whole-percent saving of price against compare_at, or 0 */
  D.saving = function (price, compare) { return compare > price ? Math.round((compare - price) * 100 / compare) : 0; };

  /* ── variants ── */
  D.variant = {
    /** the variant whose options are exactly opts (array, in option order) */
    byOptions: function (variants, opts) {
      var key = opts.join('|');
      for (var i = 0; i < variants.length; i++) if (variants[i].options.join('|') === key) return variants[i];
      return null;
    },
    bySku: function (variants, sku) {
      for (var i = 0; i < variants.length; i++) if (variants[i].sku === sku) return variants[i];
      return null;
    }
  };

  /* ── the cart: one call, the drawer opens, errors in words ──
     items: [{ id, quantity, properties }]; opts: { btn, busy, msg: element, ok, fail, after() — runs last, e.g. to re-disable an unavailable button } */
  D.cartAdd = function (items, opts) {
    opts = opts || {};
    var btns = [].concat(opts.btn || []), msg = opts.msg, labels = btns.map(function (b) { return b.textContent; });
    btns.forEach(function (b) { b.disabled = true; if (opts.busy) b.textContent = opts.busy; });
    if (msg) msg.hidden = true;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || ''); return j; }); })
      .then(function (j) {
        if (msg) { msg.textContent = opts.ok || 'Adăugat în coș ✓'; msg.classList.add('dcfg-msg'); msg.classList.remove('is-err'); msg.classList.add('is-ok'); msg.hidden = false; }
        // the theme's cart drawer listens for this (theme.js); every add-to-cart path must send it
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: j, addToCartBtn: btns[0] } }));
        return j;
      })
      .catch(function (err) {
        if (msg) { msg.textContent = err.message || opts.fail || 'A apărut o eroare. Încearcă din nou.'; msg.classList.add('dcfg-msg'); msg.classList.remove('is-ok'); msg.classList.add('is-err'); msg.hidden = false; }
        throw err;
      })
      .finally(function () { btns.forEach(function (b, i) { b.disabled = false; b.textContent = labels[i]; }); if (opts.after) opts.after(); });
  };

  /* ── the address: set or remove parameters, never wipe the others (?view= keeps a beta template) ── */
  D.url = {
    get: function (k) { try { return new URLSearchParams(location.search).get(k); } catch (e) { return null; } },
    set: function (obj) {
      try {
        var u = new URL(location.href);
        Object.keys(obj).forEach(function (k) { if (obj[k] == null || obj[k] === '') u.searchParams.delete(k); else u.searchParams.set(k, obj[k]); });
        history.replaceState(history.state, '', u);
      } catch (e) {}
    }
  };

  /** copy this page's address; the button says so, or shows the link when the browser refuses */
  D.copyLink = function (btn, done) {
    var url = location.href, label = btn.textContent;
    function after(ok) { btn.textContent = ok ? (done || 'Link copiat ✓') : url; setTimeout(function () { btn.textContent = label; }, ok ? 2000 : 8000); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(function () { after(true); }, function () { after(false); });
    else after(false);
  };

  /* ── drag and drop to reorder a list, and drop new items into it ──
     list: the container; items carry data-drag="<index>"; on touch only the .dcfg-grip starts a drag (the page still scrolls).
     opts.onMove(from, to)        an item moved (indices in the list before the move)
     opts.onDrop(data, index)     something dragged from elsewhere (HTML5, desktop) with data-dragadd="<data>" was dropped at index
     opts.count()                 how many items the list holds now (for the empty-list drop target)
     Returns { justDragged() } so a click handler can ignore the click that ends a drag. */
  D.sortable = function (list, opts) {
    var drag = null, dragged = false, scope = opts.scope || list.parentNode;
    function insertAt(x, y) {
      var best = null;
      list.querySelectorAll('[data-drag]').forEach(function (el) {
        if (drag && drag.el === el) return;
        var r = el.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        var d = Math.hypot(x - cx, (y - cy) * 2);          // rows wrap: a card on the same row is nearer than one above
        if (!best || d < best.d) best = { d: d, i: +el.dataset.drag, after: x > cx };
      });
      return best ? best.i + (best.after ? 1 : 0) : opts.count();
    }
    function mark(ins) {
      list.querySelectorAll('.is-drop-before, .is-drop-after').forEach(function (el) { el.classList.remove('is-drop-before', 'is-drop-after'); });
      var n = opts.count();
      list.classList.toggle('is-drop-empty', ins != null && !n);
      if (ins == null || !n) return;
      var el = list.querySelector('[data-drag="' + Math.min(ins, n - 1) + '"]');
      if (el) el.classList.add(ins >= n ? 'is-drop-after' : 'is-drop-before');
    }
    list.addEventListener('pointerdown', function (e) {
      var p = e.target.closest('[data-drag]');
      if (!p || e.target.closest('button') || (e.pointerType !== 'mouse' && !e.target.closest('.dcfg-grip'))) return;
      drag = { i: +p.dataset.drag, el: p, x0: e.clientX, y0: e.clientY, on: false };
      if (e.pointerType !== 'mouse') e.preventDefault();
    });
    document.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
      if (!drag.on && Math.hypot(dx, dy) < 6) return;
      drag.on = true; drag.el.classList.add('is-dragging');
      drag.el.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
      drag.ins = insertAt(e.clientX, e.clientY); mark(drag.ins);
      e.preventDefault();
    }, { passive: false });
    function end(apply) {
      if (!drag) return;
      var d = drag; drag = null;
      if (!d.on) return;
      dragged = true; setTimeout(function () { dragged = false; }, 0);
      d.el.style.transform = ''; d.el.classList.remove('is-dragging'); mark(null);
      if (apply && d.ins != null) opts.onMove(d.i, d.ins > d.i ? d.ins - 1 : d.ins);
    }
    document.addEventListener('pointerup', function () { end(true); });
    document.addEventListener('pointercancel', function () { end(false); });
    if (opts.onDrop) {
      scope.addEventListener('dragstart', function (e) {
        var b = e.target.closest('[data-dragadd]'); if (!b) return;
        e.dataTransfer.setData('text/plain', b.dataset.dragadd); e.dataTransfer.effectAllowed = 'copy';
      });
      list.addEventListener('dragover', function (e) { e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; mark(insertAt(e.clientX, e.clientY)); });
      list.addEventListener('dragleave', function (e) { if (!list.contains(e.relatedTarget)) mark(null); });
      list.addEventListener('drop', function (e) {
        e.preventDefault();
        var data = e.dataTransfer.getData('text/plain'), ins = insertAt(e.clientX, e.clientY);
        mark(null); if (data) opts.onDrop(data, ins);
      });
    }
    return { justDragged: function () { return dragged; } };
  };

  /* ── phone bar: shown once the visitor has reached the configurator, hidden while the buy box is on screen ── */
  D.stickyBar = function (bar, buy, area) {
    if (!bar || !('IntersectionObserver' in w)) return;
    var seen = false, inView = false;
    new IntersectionObserver(function (es) { inView = es[0].isIntersecting; bar.hidden = inView || !seen; }).observe(buy);
    new IntersectionObserver(function (es) { seen = es[0].isIntersecting || seen; bar.hidden = inView || !seen; }).observe(area);
  };

  /* ── photos: list = [{ src, th, c (caption HTML), flip, room, cls }]; returns the HTML of a main picture,
     its caption and the thumbnails (buttons data-photo="<i>"), plus an optional note ── */
  D.photosHtml = function (list, pick, note) {
    var cur = list[Math.min(pick, list.length - 1)];
    if (!cur) return '';
    function cls(p) { return [p.flip ? 'is-flip' : '', p.room ? 'is-room' : '', p.cls || ''].join(' ').trim(); }
    return '<div class="dcfg-photos__main"><img class="' + cls(cur) + '" src="' + cur.src + '" alt=""></div>' +
      '<p class="dcfg-photos__cap">' + (cur.c || '') + '</p>' +
      (list.length > 1 ? '<div class="dcfg-photos__thumbs">' + list.map(function (p, i) {
        return '<button type="button" data-photo="' + i + '" aria-label="Fotografia ' + (i + 1) + '" aria-current="' + (p === cur ? 'true' : 'false') + '">' +
          '<img src="' + (p.th || p.src) + '" alt=""' + (p.flip ? ' class="is-flip"' : '') + ' loading="lazy"></button>';
      }).join('') + '</div>' : '') + (note || '');
  };

  /** add ?width= to a Shopify CDN image */
  D.sized = function (src, px) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + px : ''; };

  w.Dcfg = D;
})(window);
